import React, {useEffect} from 'react'
import facultyStyle from "../components/css/facultyStyle.module.scss"
import HorizontalScroller from '../components/libs/HorizontalScroller'


export default function({id, team}){
  
    // i'm generating a random id, because if I want to reuse this component
    // multiple pages I want to be able to reference this specific slideshow
    //const randomElementId = "slideshow-"+Math.floor(Math.random() * 31) + 50;
    let oHorSlide;
    let slideController;

    useEffect(function(){
        oHorSlide = new HorizontalScroller(document.getElementById(id));
        
        /* this is just dealing with the controller of the slide show */
        slideController = document.getElementById(id).querySelector(".slidecontrol");
        console.log(oHorSlide.numberOfSlides);
        if(oHorSlide.numberOfSlides===1)
        {
            slideController.style.display = "none";
        }
    }, []);

    const nextSlide = function(){
        oHorSlide.nextSlide();
    }

    const prevSlide = function(){
        oHorSlide.prevSlide();
    }

    return(
        <aside id={id} className={"horscroll "+facultyStyle.slideshow}>
            <div className={"keyhole "+facultyStyle.keyhole}>
                <div className={"strip "+facultyStyle.slidestrip}>
                    {
                        team.map(person=> 
                            <article className={facultyStyle.slideContent}>
                                <div className={facultyStyle.slideHeader}>
                                    <div className={facultyStyle.image} style={{backgroundImage: "url(http://api.vanarts.com/assets/"+person.image+")"}}></div>
                                    <h3>{person.name}</h3>
                                    <h4>{person.longPosition}</h4>
                                </div>
                                <div  className={facultyStyle.bio} dangerouslySetInnerHTML={{__html: person.bio}}></div>
                            </article>
                        )
                    }
                </div>
            </div>
            <div className={"slidecontrol "+facultyStyle.slideControl+ " "+facultyStyle.slideControlOnSlide}>
                <button className={facultyStyle.roundArrowLeft} onClick={e=>prevSlide()}><img src="/assets/thickarrowInCircleRight.svg"/></button>
                <button className={facultyStyle.roundArrowRight} onClick={e=>nextSlide()}><img src="/assets/thickarrowInCircleRight.svg"/></button>
            </div>
        </aside>
    )
}